var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-8"},[_c('v-row',_vm._l((_vm.lawList),function(i,index){return _c('v-col',{key:index,attrs:{"cols":_vm.isMobile ? 12 : 4}},[_c('LawCard',{attrs:{"items":i}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }